import { Page, getPageModulesList } from './getPageModulesList';

export const addModulesListToPageContents = (page: Page) => {
  const list = getPageModulesList(page);
  const content = page.content.map((pageContent) => ({
    ...pageContent,
    modules_list: list,
    ...(pageContent._content_type_uid === 'layout_container' && {
      reference: pageContent.reference?.map((layoutContent) => ({
        ...layoutContent,
        modules_list: list,
      })),
    }),
  }));

  return { ...page, content };
};
